var admin = false;

function renderGlobalRecommendations(products) {
  if (products.length > 0) {
    var headSize = '20';
    var headColor = '#000000';
    var headText = 'RECOMMENDED PRODUCTS';
    $('#recommend-box').append('<h3 style="text-align: center; font-size:' + headSize + 'px; color:' + headColor + '">' + headText + '</h3><section class="global-recommendations slider productlist" style="margin-bottom:65px;"></section>');
  }
  for (var i = 0; i < products.length; i++) {
    var url = 'https://oldnewhouse.com/products/' + products[i].handle + '?view=quickView-json';
    var count = products.length;
    var t = 0;
    $.ajax({
      type: "GET",
      url: url,
      crossDomain: true,
      success: function (res) {
        var product = JSON.parse(res);
        var $container = $('.global-recommendations');
        var quickViewBtn = '<div handle="' + product.handle + '" class="quick-view-btn"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.640625 74.980469-181.019531s-26.628906-132.667969-74.980469-181.019531zm-181.019531 397.019531c-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216-96.898438 216-216 216zm20-236.019531h90v40h-90v90h-40v-90h-90v-40h90v-90h40zm0 0"/></svg></div>';
        var icon = '';

        if (product.icon_availability === "1") {
          icon = '<img style="display: inline-block; padding-left: 5px; max-height: 25px; max-width: 25px; margin-bottom: -5px;" class="product-top-icon" src="//oldnewhouse.com/cdn/shop/t/238/assets/product_icon.png?v=98548708645245234131792787652" alt="Ships in 1 - 2 Business Days!"  title="Ships in 1 - 2 Business Days!" data-icon-product/>';
        }
        var img = '<div class="imgcont"><a target="_blank" class="imgswitch" title="' + product.title + '" href="/products/' + product.handle + '"><img src="' + product.featured_image + '" alt="' + product.title + '" style="opacity: 1;"><div class="altimgcont"><img class="altimg" src="' + (product.images[1] ? product.images[1] : product.featured_image) + '" alt="' + product.title + '"></div></a>' + quickViewBtn + '</div>';
        var title = '<p class="title"><a target="_blank" href="/products/' + product.handle + '">' + product.title + '</a>' + icon + '</p><a class="desc" href="/products/' + product.handle + '">' + product.description.replace(/<[^>]+>/g, '').substr(0, 99) + '...' + '</a>';
        var priceContent = product.saw_price_money;

        if (product.saw_compare_price !== product.saw_price_money) {
          priceContent = '<span class="reducedfrom">' + product.saw_compare_price + '</span> ' + product.saw_price_money;
        }

        if (product.saw_price_money === "$9,999.00") {
          priceContent = 'Contact / email for Pricing';
        }
        var price = '<div class="price" style="height: 16px;">' + priceContent + '</div>';
        $container.append('<div class="product one-third column">' + img + title + price + '</div>');

        if (typeof initProductIcons === 'function') {
          initProductIcons();
        }

        t++;
        if (t === count) {
          window.addPreviewButton();
          $(".global-recommendations").slick({
            prevArrow: '<span class="es-nav-prev">‹</span>',
            nextArrow: '<span class="es-nav-next">›</span>',
            responsive: [
              {
                breakpoint: 3024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      }
    });
  }
}

function CustomerStorage(localStorage, storefrontApi, getLocation) {

  function getStorage() {
    var storage = localStorage.getItem("elsCustomerData");
    ;
    if (storage) {
      return JSON.parse(storage);
    } else {
      return {};
    }
  }

  function setStorage(customerData) {
    localStorage.setItem("elsCustomerData", JSON.stringify(customerData));
  }

  var customerData = getStorage();

  function setLocation(countryCode) {
    customerData.location = {country_code: countryCode};
    setStorage(customerData);
  }

  function checkProductPage(url) {
    if (url.indexOf('/products/') === -1) {
      return false;
    } else {
      return true;
    }
    ;
  }

  function getUnixTodayDate() {
    var todayDate = new Date();
    return todayDate.getTime();
  }

  function addProduct(id, handle) {
    customerData.products.push({id: id, handle: handle});
  }

  function getHandleFromUrl(url) {
    return url.split("/products/")[1];
  }

  this.setSavedSearch = function (size) {
    customerData.size = size;
    setStorage(customerData);
  };

  this.addVisit = function (url) {
    if (checkProductPage(url)) {
      if (customerData.first_page_url) {
        if (customerData.products.length > 5) {
          customerData.products = customerData.products.slice(0, 5);
        }

        var productExist = false;
        customerData.products.forEach(function (product) {
          if (product.id === window.productData?.id) {
            productExist = true;
          }
        });

        if (!productExist) {
          customerData.products.shift();
          addProduct(`${window.productData?.id}`, `${window.productData?.handle}`);
        }
      } else {
        customerData.first_page_url = url;
        getLocation(setLocation);
        customerData.products = [];
        addProduct(`${window.productData?.id}`, `${window.productData?.handle}`);
      }
      setStorage(customerData);
    }
    ;

    this.getSearchParams = function (callback) {
      var params = {};
      var firstVisitedProduct = 'default state';
      var cartItemsSizes = 'default state';
      var cartItemsColors = 'default state';

      function getSizeRange(sizes) {
        var sizeRange = {width_min: 0, width_max: 0, length_min: 0, length_max: 0};
        var length = [];
        var width = [];
        sizes.forEach(function (size) {
          if (size.width !== null) {
            width.push(Number.parseInt(size.width));
          }
          if (size.length !== null) {
            length.push(Number.parseInt(size.length));
          }
        });
        length = length.sort(function compareNumbers(a, b) {
          return a - b;
        });
        width = width.sort(function compareNumbers(a, b) {
          return a - b;
        });
        sizeRange.length_max = length[length.length - 1];
        sizeRange.length_min = length[0];
        sizeRange.width_max = width[width.length - 1];
        sizeRange.width_min = width[0];
        var delta = 0;
        if (customerData.size) {
          delta = customerData.size.delta;
        }
        sizeRange.delta = delta;
        return sizeRange;
      }

      function getTopColors(colors, limit) {
        var summedColors = {};
        var topColors = [];
        colors.forEach(function (item) {
          if (item !== null) {
            if (summedColors[item.color] == undefined) {
              summedColors[item.color] = item.value;
            } else {
              summedColors[item.color] = Number(parseFloat(item.value + summedColors[item.color]).toFixed(2));
            }
          }
        });
        for (var key in summedColors) {
          topColors.push({color: key, value: Number(parseFloat(summedColors[key] / 100).toFixed(2))});
        }
        topColors = topColors.sort(function (a, b) {
          if (a.value < b.value) {
            return 1;
          }
          if (a.value > b.value) {
            return -1;
          }

          return 0;
        });
        return topColors.slice(0, limit);
      }

      function getLastVisitedProductsIds() {
        var lastVisitedProducts = customerData.products.sort(function (a, b) {
          if (a.last_visited < b.last_visited) {
            return 1;
          }
          if (a.last_visited > b.last_visited) {
            return -1;
          }

          return 0;
        });

        var lastVisitedProductsIds = lastVisitedProducts.map(function (product) {
          return Number.parseInt(product.id);
        });

        return lastVisitedProductsIds.slice(0, 5);
      }

      function getNoSearchOrigin() {
        var noSearchOrigin = [];
        console.log('location' in customerData, customerData.location.country_code !== 'US', customerData.location.country_code);

        if ('location' in customerData && customerData.location.country_code !== 'US') {
          noSearchOrigin.push('Persia');
        }

        return noSearchOrigin;
      }

      function calculateParams(firstVisitedProduct, cartItemsSizes) {
        if (customerData.size) {
          var size = customerData.size;
          var delta = size.delta;
          params.size = {
            width_min: size.width_min, width_max: size.width_max,
            length_min: size.length_min, length_max: size.length_max, delta: delta
          };
        } else {
          var allSizes = [];
          if (Object.keys(firstVisitedProduct).length !== 0 && firstVisitedProduct.hasOwnProperty('size')) {
            allSizes.push(firstVisitedProduct.size);
          }

          if (cartItemsSizes.length !== 0) {
            allSizes = allSizes.concat(cartItemsSizes);
          }

          if (allSizes.length !== 0) {
            params.size = getSizeRange(allSizes);
          }
        }

        var allColors = [];
        var lastVisitedProductsIds = [];
        if (Object.keys(firstVisitedProduct).length !== 0) {
          if (firstVisitedProduct.colors) {
            allColors = allColors.concat(firstVisitedProduct.colors);
          }
          params.lastProducts = getLastVisitedProductsIds();
          params.noSearchOrigin = getNoSearchOrigin();
        }
        if (cartItemsColors) {
          cartItemsColors.forEach(function (cartItemColors) {
            allColors = allColors.concat(cartItemColors);
          });
        }
        if (allColors.length !== 0) {
          params.colors = getTopColors(allColors, 10);
        }

        callback(params);
      }

      function setCartItemsSizeAndColors(cartItemsData) {
        var count = cartItemsData.length;
        var allCartSizes = [];
        var allCartColors = [];
        for (var i = 0; i < count; i++) {
          storefrontApi.getProduct(cartItemsData[i].handle, function (item) {
            allCartSizes.push(item.size);
            allCartColors.push(item.colors);
          });
        }

        function checkItemsSizesResponse(itemsSizesResponse) {
          setTimeout(function () {
            if (itemsSizesResponse.length !== count) {
              checkItemsSizesResponse(allCartSizes);
            } else {
              cartItemsColors = allCartColors;
              cartItemsSizes = allCartSizes;
            }
          }, 100);
        }

        checkItemsSizesResponse(allCartSizes);
      }

      function checkResponse(productResponse, cartResponse) {
        setTimeout(function () {
          if (productResponse === 'default state' || cartResponse === 'default state') {
            checkResponse(firstVisitedProduct, cartItemsSizes);
          } else {
            calculateParams(productResponse, cartResponse);
          }
        }, 100);
      }


      if (customerData.first_page_url) {
        var firstVisitedProductHandle = getHandleFromUrl(customerData.first_page_url);
        storefrontApi.getProduct(firstVisitedProductHandle, function (productData) {
          firstVisitedProduct = productData;
        });
      } else {
        firstVisitedProduct = {};
      }

      storefrontApi.getCartItems(setCartItemsSizeAndColors);
      checkResponse(firstVisitedProduct, cartItemsSizes);
    };
  };
}
var storefrontApi = {
  getCartItems: function (callback) {
    $.ajax({
      url: "/cart.js",
      success: function (cart) {
        callback(cart.items)
      },
      dataType: "json"
    });
  },
  getProduct: function (handle, callback) {
    url = 'https://oldnewhouse.com/products/' + handle.split('?')[0] + '?view=elspw-json';
    $.get(url, function (res) {
      var product = JSON.parse(res);
      callback(product);
    });
  }
};

var searchApi = {
  getByParams: function (params, callback) {

    var url = 'https://staging-app.oldnewhouse.com/api/global-recommendations';
    $.ajax({
      type: "POST",
      data: {params: params, shop: "frieddill.myshopify.com"},
      dataType: "json",
      url: url,
      crossDomain: true,
      success: function (res) {
        callback(res);
      }
    });
  }
};

function getLocation(callback) {
  $.get("https://ipinfo.io", function (result) {
    callback(result.country);
  }, "jsonp");
}

var storage = new CustomerStorage(window.localStorage, storefrontApi, getLocation);
storage.addVisit(window.location.href);

$searchForm = $('#onh-f-form');
$searchForm.on('submit', function (data) {

  function getInput(name) {
    return $searchForm.find('[name=' + name + ']').first();
  }

  function getInputValue(name) {
    var input = getInput(name);
    if (input.val() === undefined) {
      return 0;
    }

    return input.val().length ? parseInt(input.val()) : 0;
  }

  var minWidth = getInputValue('min_width_ft') * 12 + getInputValue('min_width_in');
  var maxWidth = getInputValue('max_width_ft') * 12 + getInputValue('max_width_in');
  var minLength = getInputValue('min_length_ft') * 12 + getInputValue('min_length_in');
  var maxLength = getInputValue('max_length_ft') * 12 + getInputValue('max_length_in');
  var sizeDelta = getInputValue('extend_value');

  storage.setSavedSearch({
    width_min: minWidth,
    width_max: maxWidth,
    length_min: minLength,
    length_max: maxLength,
    delta: sizeDelta
  });
});

if (window.baseConfig?.template.includes('product')) {
  storage.getSearchParams(function (params) {
    searchApi.getByParams(params, function (recommendedProducts) {
      renderGlobalRecommendations(recommendedProducts);
    })
  });
}